import React, { useEffect, useState } from 'react';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Link } from '@hz-design-system/web-ui';

import { TListingClient, TListingSellerInfo } from 'types/TListing';
import { TSellerProfileClient } from 'types/TSellerProfile';

import SellerReviews from './SellerReviews';
import calculateActiveSinceDiff from '../../../../utils/calculateActiveSinceDiff';
import getFormattedLocation from '../../../../utils/getFormattedLocation';
import { trackGAEvent } from '../../../../utils/gaTracking';
import SellerProfilePicture from '../../../SellerInfoExpandedApp/components/components/SellerProfilePicture';
import { GA_TRACK_EVENTS_ACTIONS } from '../../../../utils/constants';

import Classes from './SellerInfoSmall.scss';

type TSellerInfoProps = {
  seller: TListingSellerInfo;
  isAutomotiveAd: TListingClient['isAutomotiveAd'];
  profile: TSellerProfileClient;
};

let SmbPopOver;

const SellerInfoSmall = ({ seller, isAutomotiveAd, profile }: TSellerInfoProps) => {
  const { t } = useI18nContext();
  const { name, activeSince, location, pageUrl } = seller;
  const activeSinceDiff = calculateActiveSinceDiff(activeSince, t);
  const formattedLocation = getFormattedLocation(location, t);
  const isTrader = seller.sellerType === 'TRADER';
  const [isSmbPopOverLoaded, setIsSmbPopOverLoaded] = useState(false);
  const isSmbVerified = !isAutomotiveAd && Boolean(profile.smbVerified);

  useEffect(() => {
    if (isSmbVerified && !isSmbPopOverLoaded) {
      const loadSmbPopOver = async () => {
        try {
          SmbPopOver = (
            await import(
              /* webpackChunkName: "SmbPopOver" */ '../../../SellerInfoExpandedApp/components/components/SmbPopOver'
            )
          ).default;
          setIsSmbPopOverLoaded(true);
        } catch (err) {}
      };

      loadSmbPopOver();
    }
  }, [isSmbPopOverLoaded, isSmbVerified]);

  const fireGAOnClick = () => {
    trackGAEvent(GA_TRACK_EVENTS_ACTIONS.OPEN_SELLER_PAGE);
  };

  return (
    <div className={Classes.root}>
      <div className={Classes.image}>
        <SellerProfilePicture
          isLogo={isTrader}
          name={name}
          imageSrc={profile.profilePictures?.logoPicture || profile.profilePictures?.profilePicture}
        />
      </div>
      <div className={Classes.section}>
        <div className={`${Classes.row} ${Classes.name}`}>
          <Link href={pageUrl} onClick={fireGAOnClick}>
            {name}
          </Link>
          {isSmbPopOverLoaded && <SmbPopOver />}
        </div>
        {isAutomotiveAd && <div className={Classes.row}>{formattedLocation}</div>}
        {!isAutomotiveAd && (
          <Trans className={Classes.row} i18nKey="sellerInfo.activeOnPlatform" activeSinceDiff={activeSinceDiff} />
        )}
        <div className={Classes.row}>
          <SellerReviews seller={seller} profile={profile} />
        </div>
      </div>
    </div>
  );
};

export default SellerInfoSmall;
